import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Objectives section for FAQ Page
 */
const ObjectivesSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="objectives-section-component"
    >
      <AccordionV2
        testId="objectives"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="What are the objectives of Singapore Corporate Awards?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-4 pb-0">
          <p>The objectives of the Singapore Corporate Awards (SCA) are:</p>

          <ul className="list-outside list-decimal pl-8">
            <li className="mb-4">
              To recognise and honour SGX-listed companies as well as
              individuals who, through their corporate practices, have helped to
              raise Singapore&apos;s corporate disclosure standards and
              corporate governance.
            </li>
            <li className="mb-4">
              To showcase SGX-listed companies and key decision makers who
              effectively implement and promote corporate disclosure standards
              and corporate governance in their companies.
            </li>
            <li className="mb-4">
              To create a prestigious corporate event for SGX-listed
              companies&apos; Chief Executive Officers, Chief Financial
              Officers, Directors and substantial shareholders to network,
              socialise and share ideas and views on good corporate governance.
            </li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ObjectivesSection;
